import { MEDIUM_DATE } from '../constants/dates';
import dateFormatter from './dateFormatter';

export default function mediumDate(date: any, timeZone: any) {
  return dateFormatter(date, MEDIUM_DATE, timeZone);
}
